module.exports = __webpack_public_path__ + "img/5.f550eea8.png";